module.exports = __webpack_public_path__ + "img/2.ead59fa9.jpg";